import {registerState} from './atoms'

import {useRecoilState} from 'recoil'
import React from 'react'
import {InputBase} from "../common";

type Props = {
    type: string
    name: string
    placeholder: string
    disabled?: boolean
}

const Input: React.FC<Props> = ({type, name, placeholder, disabled = false}: Props) => {
    const [state, setState] = useRecoilState(registerState)

    return (
        <InputBase
            disabled={disabled}
            className={'auth_input'}
            type={type}
            name={name}
            placeholder={placeholder}
            state={state}
            setState={setState}
        />
    )
}

export default Input
